"use client";

import { useEffect, useState } from "react";
import type { GeneralSettingSection } from "@/app/(dashboard)/dashboard/webmaster/general-setting/general-setting-defaults";
import type { SwitcherLanguage } from "@/components/language-switcher";
import { Header } from "../components/cambodia-food-expo/sections/Header";
import { FooterSection } from "../components/cambodia-food-expo/sections/FooterSection";
import { Container } from "../components/cambodia-food-expo/ui/Container";

const title = "វីដេអូសង្ខេបក្រោយព្រឹត្តិការណ៍";

export function RecapVideoClient({
  generalSetting,
  languages,
}: {
  generalSetting: GeneralSettingSection;
  languages: SwitcherLanguage[];
}) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main
      className="min-h-screen overflow-x-clip bg-[#071b4a] text-white"
      style={{ fontFamily: "var(--font-food-expo-body), sans-serif" }}
    >
      <Header isScrolled={isScrolled} data={generalSetting} languages={languages} />
      <section className="relative overflow-hidden bg-[linear-gradient(180deg,#061941_0%,#030d24_100%)] px-5 py-[clamp(56px,9vw,108px)] md:px-6">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0">
          <div className="absolute inset-0 opacity-[0.05] [background-image:radial-gradient(circle,#F5C542_1px,transparent_1.4px)] [background-size:26px_26px]" />
          <div className="absolute left-[12%] top-[-5%] h-[34rem] w-[34rem] rounded-full bg-[#f5c542]/10 blur-3xl" />
        </div>
        <Container className="relative max-w-[1240px]">
          <h1 className="mb-[clamp(32px,5vw,56px)] text-center text-[clamp(26px,3.6vw,42px)] font-bold leading-[1.45] text-[#f5c542] drop-shadow-[0_2px_24px_rgba(245,197,66,0.18)]">
            {title}
          </h1>
          <div className="overflow-hidden rounded-2xl border border-[#f5c542]/20 bg-black shadow-[0_24px_64px_rgba(0,0,0,0.35)]">
            <iframe
              src="https://www.youtube-nocookie.com/embed/hZ7uBzjgaDo"
              title={title}
              className="aspect-video w-full border-0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </Container>
      </section>
      <FooterSection data={generalSetting} />
    </main>
  );
}
